var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCsvCtv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99707 11.5007L7.99707 9.50073L5.99707 11.5007",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 9.50073V13.5007",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5783 12.5C13.1102 12.189 13.5305 11.6969 13.7727 11.1013C14.0148 10.5057 14.0652 9.84065 13.9157 9.21099C13.7663 8.58133 13.4256 8.02298 12.9474 7.62404C12.4691 7.22511 11.8806 7.00832 11.2748 7.0079H10.5876C10.4225 6.32313 10.1148 5.68741 9.68762 5.14853C9.26046 4.60965 8.72493 4.18163 8.12131 3.89664C7.51768 3.61166 6.86167 3.47713 6.20258 3.50317C5.5435 3.52921 4.89849 3.71515 4.31606 4.04699C3.73363 4.37884 3.22893 4.84796 2.8399 5.41909C2.45087 5.99022 2.18763 6.6485 2.06998 7.34444C1.95233 8.04037 1.98333 8.75585 2.16065 9.43709C2.33796 10.1183 2.65698 10.7476 3.09372 11.2776",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99707 11.5007L7.99707 9.50073L5.99707 11.5007",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCsvCtv);
export default __webpack_public_path__ + "static/media/upload_csv_ctv.7bbeaf68df99148459fbee9f1bb51644.svg";
export { ForwardRef as ReactComponent };